import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ProjectRelatedEntitiesAmountResponse } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, ProjectRelatedEntitiesAmountResponse>,
    'queryKey' | 'queryFn'
  >;
}

export const useProjectRelatedEntitiesAmountRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, ProjectRelatedEntitiesAmountResponse>(
    [Entities.Projects, id, 'amount-of-related-entities'],
    async () => {
      const { data } = await api.v1AdminProjectsProjectIdAmountRelatedEntitiesGet(id)
      return data as ProjectRelatedEntitiesAmountResponse
    },
    options,
  )
}
